<template>
	<div
		class="app-table-wrapper"
		:class="{ 'app-table-contained': contained }"
	>
	<table
		class="table-list"
		:class="[
			appearanceClass,
			{
				'table-compact': compact,
				'table-contained': contained,
				'table-selectable': selectable,
				'table-sticky-header': stickyHeader,
			},
		]"
		border="0"
		cellpadding="0"
		cellspacing="0">
		<colgroup v-if="hasColumnWidths">
			<col v-if="selectable" style="width: 44px">
			<col
				v-for="column in columns"
				v-if="column.visible"
				:key="`column-width-${column.id}`"
				:style="{ width: columnWidths[column.id] || 'auto' }"
			>
		</colgroup>
		<thead class="primary">
			<tr v-if="inputSearch || filterColumns || includeFilter || addButton">
				<th :colspan="totalVisibleColumns">
					<div class="table-tools-row">
						<div class="table-tools-title">
							<span><v-icon>view_list</v-icon></span>
							<div><strong>Registros</strong><small>{{ formattedRecordTotal }} disponibles</small></div>
						</div>
						<div class="table-tools-actions" :class="`text-xs-${direction}`">
					<div
						class="search-input align-center"
						v-if="inputSearch">
						<input
							v-model="search"
							type="text"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						/>
						<v-icon
							class="search-icon"
							size="20"
						>
							search
						</v-icon>
					</div>
					<v-menu
						offset-y
						max-height="300"
						content-class="columns-menu"
						fixed
						v-model="showMenu"
						v-if="filterColumns"
						:close-on-content-click="false">
						<button type="button" slot="activator">
							<v-icon color="white">view_column</v-icon>
						</button>
						<div class="content-checkbox">
							<v-checkbox
								v-model="column.checked"
								:label="column.name"
								v-for="column in columns"
								:key="column.id"
								hide-details
								v-if="!column.flagVisible"
								color="success"
								class="filter-columns"
								style="background: white;width: 300px; line-height: normal">
							</v-checkbox>
							<div class="apply text-xs-center">
								<v-btn @click="toggleColumns" class="btn-action mb-2 mt-2" color="primary">Aplicar</v-btn>
							</div>
						</div>
					</v-menu>
					<button
						v-if="includeFilter"
						type="button"
						@click="tableOption">
						<v-icon>filter_list</v-icon>
					</button>
					<button
						v-if="addButton"
						type="button"
						@click="addOption">
						<v-icon>add</v-icon>
					</button>
						</div>
					</div>
				</th>
			</tr>
			<tr>
				<th v-if="selectable">
					<input
						type="checkbox"
						:value="checkAll"
						:checked="checkAll"
						class="input-checkbox"
						v-on:change="selectedAll($event)"
						:disabled="disabledTable">
				</th>
				<th is="table-column-item" v-for="column in columns" v-bind:key="column.id"
				  v-bind:column="column" v-show="column.visible" class="text-xs-center">
				</th>
			</tr>
		</thead>
		<tbody>
			<template>
				<tr v-for="row in rows"
					v-bind:key="row[keyValue]"
					:class="{ 'row-checked' : row[selectedValue] }"
					>
					<td v-if="selectable">
						<input
							@click="rowIsSelected(row)"
							type="checkbox"
							v-model="row[selectedValue]"
							class="input-checkbox"
							:disabled="row.disabled">
					</td>
					<slot name="rows" v-bind:row="row"></slot>
				</tr>
			</template>
		</tbody>
		<tfoot class="table-pagination">
			<tr v-if="mainList && rows.length > 0">
				<td :colspan="totalVisibleColumns">
					<div class="pagination-footer">
						<div class="pagination-summary">
							<span class="records-badge">{{ formattedRecordTotal }}</span>
							<span>registros totales · Mostrando <strong>{{ rows.length }}</strong> en esta página</span>
							<span class="pagination-divider"></span>
							<span>Página <strong>{{ currentPage }}</strong> de <strong>{{ lastPage }}</strong></span>
						</div>
						<nav class="pagination-controls" aria-label="Paginación de la tabla">
							<button type="button" title="Primera página" :disabled="currentPage <= 1" @click="selectPage(1)">
								<v-icon>first_page</v-icon>
							</button>
							<button type="button" title="Página anterior" :disabled="currentPage <= 1" @click="selectPage(currentPage - 1)">
								<v-icon>chevron_left</v-icon>
							</button>
							<button
					v-for="(page, index) in pages"
					:key="index"
					class="page-number"
					:class="{ 'active-page': page === currentPage, 'page-dots': page === '...' }"
					:disabled="page === '...'"
					@click="selectPage(page)"
					>{{page}}</button>
							<button type="button" title="Página siguiente" :disabled="currentPage >= lastPage" @click="selectPage(currentPage + 1)">
								<v-icon>chevron_right</v-icon>
							</button>
							<button type="button" title="Última página" :disabled="currentPage >= lastPage" @click="selectLastPage">
								<v-icon>last_page</v-icon>
							</button>
						</nav>
					</div>
				</td>
			</tr>
			<tr v-if="rows.length === 0">
				<td :colspan="totalVisibleColumns">
					<p style="text-align:center; margin: 5px 0 0 5px">
						No hay información que mostrar
					</p>
				</td>
			</tr>
		</tfoot>
	</table>
	</div>
</template>

<script>

import TableColumnItem from './table-column-item';
import helper from './../../../shared/helper';

const ADD_REQUEST_EVENT = 'on-add-event';
const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';
const ON_DRAG_EVENT = 'on-drag-event';
const ON_DRAG_ENTER = 'on-drag-enter';
const ON_DRAG_LEAVE = 'on-drag-leave';
const ON_DROP_EVENT = 'on-drop-event';
const ON_PAGE_EVENT = 'on-page';
const ROW_IS_SELECTED = 'row-is-selected';
const SELECTED_ALL_EVENT = 'on-selected-all';
const TABLE_OPTION_EVENT = 'table-option-event';

const components = {
	TableColumnItem,
};

function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}

function pagination(pageNumber, totalRecords) {
	const current = pageNumber;
	const last = totalRecords;
	const delta = 2;
	const left = current - delta;
	const right = current + delta + 1;
	const range = [];
	const rangeWithDots = [];
	let l = null;

	for (let i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}

	/* eslint-disable no-restricted-syntax */
	for (const i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push('...');
			}
		}
		rangeWithDots.push(i);
		l = i;
	}

	return rangeWithDots;
}

function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false,
	};
}

function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	document.addEventListener('click', this.closeActionMenus);
	this.optionsDirection();
	const columnsInLocalStorage = helper.getLocalData(`${this.$attrs.name}::columns`);
	if (columnsInLocalStorage) {
		this.columns.forEach((col) => {
			const newCol = col;
			const colToChange = columnsInLocalStorage.find(c => c.id === newCol.id);
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		const searchFromLocalStorage = helper.getLocalData(`${this.$attrs.name}::search`);
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
	this.$nextTick(this.decorateActionMenus);
}

function updated() {
	this.$nextTick(this.decorateActionMenus);
}

function beforeDestroy() {
	window.removeEventListener('resize', this.optionsDirection);
	document.removeEventListener('click', this.closeActionMenus);
}

function closeActionMenus(event) {
	if (event && event.target.closest('.table-action-menu')) {
		return;
	}
	this.$el.querySelectorAll('.table-action-menu.open').forEach(menu => menu.classList.remove('open'));
}

function actionColor(action) {
	const label = (action.getAttribute('aria-label') || '').toLowerCase();
	const icon = action.querySelector('.material-icons');
	const iconName = icon ? icon.textContent.trim() : '';
	if (/editar/.test(label) || /edit|create/.test(iconName)) return '#3B82C4';
	if (/eliminar|borrar/.test(label) || /delete|highlight_off/.test(iconName)) return '#ef5350';
	if (/proceso|configurar/.test(label) || /build|settings/.test(iconName)) return '#e39122';
	if (/recurso/.test(label) || /cached|sync/.test(iconName)) return '#1A4338';
	if (/rol|permiso/.test(label) || /developer_board|lock/.test(iconName)) return '#7657d5';
	if (/detalle|ver/.test(label) || /visibility/.test(iconName)) return '#35a85b';
	if (/compañ|crear|nueva|agregar/.test(label) || /add/.test(iconName)) return '#1A4338';
	if (/usuario|dispositivo/.test(label) || /people|devices/.test(iconName)) return '#4f6fd3';
	if (/integr|compartir/.test(label) || /share/.test(iconName)) return '#1a9b7a';
	const classes = action.className;
	if (/red--text|error--text/.test(classes)) return '#ef5350';
	if (/green--text|success--text/.test(classes)) return '#35a85b';
	if (/orange--text|warning--text/.test(classes)) return '#f59e0b';
	if (/primary--text|primary--text|info--text|infor--text/.test(classes)) return '#1A4338';
	return '#607d8b';
}

function decorateActionMenus() {
	const actionCells = this.$el.querySelectorAll('tbody td:last-child');
	actionCells.forEach((cell) => {
		const actions = Array.from(cell.querySelectorAll('.action-icon-button'));
		if (actions.length < 2 || cell.querySelector('.table-action-menu')) {
			return;
		}
		cell.classList.add('table-action-cell');
		actions[0].classList.add('table-primary-action');
		actions.slice(1).forEach(action => action.classList.add('table-secondary-action'));
		const menu = document.createElement('div');
		menu.className = 'table-action-menu';
		const trigger = document.createElement('button');
		trigger.type = 'button';
		trigger.className = 'table-action-trigger';
		trigger.setAttribute('aria-label', 'Más acciones');
		trigger.setAttribute('title', 'Más acciones');
		trigger.innerHTML = '<i class="material-icons">more_horiz</i>';
		const popover = document.createElement('div');
		popover.className = 'table-action-popover';
		actions.slice(1).forEach((action) => {
			const item = document.createElement('button');
			item.type = 'button';
			item.className = 'table-action-item';
			item.style.setProperty('--action-color', actionColor(action));
			const icon = action.querySelector('.material-icons');
			item.innerHTML = `<i class="material-icons">${icon ? icon.textContent : 'arrow_forward'}</i><span>${action.getAttribute('aria-label') || 'Acción'}</span>`;
			item.addEventListener('click', (event) => {
				event.stopPropagation();
				action.click();
				menu.classList.remove('open');
			});
			popover.appendChild(item);
		});
		trigger.addEventListener('click', (event) => {
			event.stopPropagation();
			const wasOpen = menu.classList.contains('open');
			this.closeActionMenus();
			const bounds = trigger.getBoundingClientRect();
			popover.style.right = `${window.innerWidth - bounds.right}px`;
			popover.style.top = `${bounds.bottom + 5}px`;
			menu.classList.toggle('open', !wasOpen);
		});
		menu.appendChild(trigger);
		menu.appendChild(popover);
		cell.appendChild(menu);
	});
}

function toggleColumns() {
	this.selectedColumns = this.columns.filter(c => !c.checked);
	this.columns.forEach((col) => {
		const newCol = col;
		const colToChange = this.selectedColumns.find(c => c.id === newCol.id);
		newCol.visible = typeof colToChange === 'undefined';
	});
	helper.setLocalData(`${this.$attrs.name}::columns`, this.selectedColumns);
	this.showMenu = false;
}

function selectedAll({ target }) {
	this.$emit(SELECTED_ALL_EVENT, target.checked);
}

function rowIsSelected(row) {
	const newRow = { ...row };
	newRow[this.selectedValue] = !newRow[this.selectedValue];
	this.$emit(ROW_IS_SELECTED, newRow);
}

function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}

function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}

function syncSearchValue(value) {
	this.search = value || '';
}

function selectPage(page) {
	let newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}

function selectLastPage() {
	changePage.call(this, this.lastPage);
}

function tableOption() {
	const action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		open: true,
		title: 'FILTRAR POR',
		width: 229,
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}

function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'left';
	} else {
		this.direction = 'right';
	}
}

function totalVisibleColumns() {
	const selectionColumn = this.selectable ? 1 : 0;
	return this.columns.filter(c => c.visible).length + selectionColumn;
}

function appearanceClass() {
	return this.appearance ? `table-${this.appearance}` : '';
}

function recordTotal() {
	const total = Number(this.rows.totalRecords);
	return Number.isNaN(total) ? this.rows.length : total;
}

function formattedRecordTotal() {
	return this.recordTotal.toLocaleString('es-EC');
}

function pages() {
	return pagination(this.currentPage, this.lastPage);
}

function hasColumnWidths() {
	return this.columnWidths && Object.keys(this.columnWidths).length > 0;
}

export default {
	name: 'app-table',
	components,
	computed: {
		appearanceClass,
		formattedRecordTotal,
		hasColumnWidths,
		pages,
		recordTotal,
		totalVisibleColumns,
	},
	data,
	methods: {
		addOption,
		actionColor,
		closeActionMenus,
		decorateActionMenus,
		onDrag,
		onDragEnter,
		onDragLeave,
		onDrop,
		optionsDirection,
		rowIsSelected,
		searchRows,
		selectedAll,
		selectPage,
		selectLastPage,
		tableOption,
		toggleColumns,
	},
	mounted,
	updated,
	beforeDestroy,
	props: {
		appearance: {
			default: 'modern',
			type: String,
		},
		addButton: {
			default: false,
			type: Boolean,
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Array,
			required: true,
		},
		columnWidths: {
			type: Object,
			default: () => ({}),
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		dispatchDetail: {
			default: false,
			type: Boolean,
		},
		filterColumns: {
			default: true,
			type: Boolean,
		},
		includeFilter: {
			type: Boolean,
			default: false,
		},
		inputSearch: {
			default: true,
			type: Boolean,
		},
		localSearch: {
			type: Boolean,
			default: false,
		},
		localStorage: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			required: true,
		},
		searchValue: {
			type: String,
			default: '',
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		keyValue: {
			type: String,
			default: 'id',
		},
		mainList: {
			type: Boolean,
			default: true,
		},
		disabledTable: {
			type: Boolean,
			default: false,
		},
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		compact: {
			default: true,
			type: Boolean,
		},
		contained: {
			default: true,
			type: Boolean,
		},
		selectedValue: {
			default: 'isSelected',
			type: String,
		},
		stickyHeader: {
			default: true,
			type: Boolean,
		},
	},
	watch: {
		cleanSearch,
		searchValue: {
			handler: syncSearchValue,
			immediate: true,
		},
	},
};

</script>

<style lang="scss" scoped>
	.app-table-wrapper {
		background: white;
		border: 1px solid #dfe7ef;
		border-radius: 12px;
		box-shadow: 0 4px 14px rgba(31, 57, 85, .06);
		padding: 0;
		width: 100%;

		&.app-table-contained {
			max-height: calc(100vh - 165px);
			overflow-x: auto;
			overflow-y: visible;
		}

		&.mt-5,
		&.my-5 {
			margin-top: 7px !important;
		}

		&.mt-4,
		&.my-4 {
			margin-top: 7px !important;
		}

		&.mt-3,
		&.my-3 {
			margin-top: 6px !important;
		}

		&.my-5,
		&.my-4,
		&.my-3 {
			margin-bottom: 12px !important;
		}
	}

	input {
		background-color: transparent;
		border-style: none;
	}

	table.table-list {
		width: 100%;

		&.table-modern {
			background: transparent;
			border-collapse: collapse;
			border-spacing: 0;
			font-family: map-get($fonts, opens-regular);

			&.mt-5,
			&.my-5 {
				margin-top: 7px !important;
			}

			&.mt-4,
			&.my-4 {
				margin-top: 7px !important;
			}

			&.mt-3,
			&.my-3 {
				margin-top: 6px !important;
			}

			&.my-5,
			&.my-4,
			&.my-3 {
				margin-bottom: 12px !important;
			}

			thead.primary tr:first-child {
				background: #1A4338;
			}

			thead.primary tr:last-child {
				background: transparent;
			}

			thead th {
				background: transparent;
				color: #7890a5;
				font-size: 9px;
				font-weight: 600;
				height: 28px;
				letter-spacing: .08em;
				padding: 0 9px;
				text-transform: uppercase;
				white-space: nowrap;

			}

			tbody tr {
				background: white;
				box-shadow: 0 1px 3px rgba(35, 59, 82, .08);
				transition: background-color .2s ease, box-shadow .2s ease, transform .2s ease;

				&:nth-child(even) {
					background: white;
				}

				&:hover {
					background: #F4F8F6;
					box-shadow: inset 3px 0 #1A4338, 0 5px 13px rgba(26, 67, 56, .12);
					transform: translateY(-1px);

					td {
						border-bottom-color: #DFEBE7;
						border-top-color: transparent;
						color: #263746;
						font-family: map-get($fonts, opens-semibold);
					}
				}

				&.row-checked {
					background: #f4fbf7;
				}

					td {
					border: 0;
					color: #40505e;
					height: 48px;
					line-height: 1.25;
					padding: 4px 8px;
					vertical-align: middle;

					&:first-child { border-radius: 9px 0 0 9px; }
					&:last-child { border-radius: 0 9px 9px 0; }
				}
			}

			&.table-selectable {
				thead th:first-child,
				tbody td:first-child {
					padding-left: 10px !important;
					padding-right: 10px !important;
					text-align: center;
					width: 44px !important;
				}
			}

			.v-text-field {
				margin: 0 auto;
				max-width: 100px;
			}

			.v-input__slot {
				border: 1px solid #dce4eb;
				box-shadow: none !important;
				min-height: 34px;
			}

			.input-checkbox {
				accent-color: #1A4338;
				cursor: pointer;
				height: 16px;
				width: 16px;
			}

			.search-input {
				background: rgba(0, 0, 0, .18);
				border: 1px solid rgba(255, 255, 255, .25);
				border-radius: 6px;
				height: 30px;
				max-width: 220px;
			}

			tfoot tr td {
				border-top-color: #e2e8ee;
				box-shadow: none;
				height: 36px;
			}

			tfoot a.active-page {
				background: #EAF3EF;
				border-radius: 4px;
				color: #1A4338;
				font-weight: 600;
			}
		}

		&.table-sticky-header {
			thead {
				position: static;
			}
		}

		&.table-sticky-header.table-contained thead {
			position: static;
		}

		&.table-contained tfoot {
			position: static;
		}

		&.table-compact {
			thead th {
				height: 38px;
			}

			tbody tr td {
				height: 40px;
				padding-bottom: 2px;
				padding-top: 2px;
			}
		}

		thead {
			color: white;

			th {
				align-items: center;
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
				font-weight: 500;
				height: 30.5px;
				padding: 0px 5px;
				text-align: center;

				&:first-child {
					padding-left: 9px;
					text-align: left;
					width: 34px;
				}

				.check-list {
					margin-top: -1px !important;
				}
			}

			tr:first-child {
				th {
					&:last-child {
						padding-right: 5px;
					}
				}
			}

			button {
				background-color: map-get($colors, success);
				border: 0px;
				border-radius: 4px;
				height: 22px;
				line-height: 22px;
				margin-left: 3px;
				outline: none;
				width: 25px;

				.icon {
					color: white;
					height: 20px;
					line-height: 19px;
				}
			}
		}

		&.is-not-selectable {
			th {
				&:first-child {
					width: auto;
				}
			}
		}

		tbody {
			tr {
				background-color: white;
				color: map-get($colors, tableText);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;

				&:nth-child(odd) {
					background: #f2f2f2;
				}

				td {
					align-items: center;
					border-right: 1px solid map-get($colors, grey-border);
					height: 30px;
					padding: 0px 5px;
					text-align: center;

					&:first-child:not(.is-not-selectable) {
						border-left: 1px solid transparent;
						border-right: 1px solid;
						padding-left: 8px;
						width: 180px;
						text-align: center;
					}

					&:last-child {
						border-right: 1px solid transparent;
					}

					.check-list {
						margin-top: -1px !important;
					}

					.table-icon {
						img {
							vertical-align: middle;
						}

						&.btn {
							background-color: transparent;
							box-shadow: none;
							margin: 0px;
							min-width: auto;
						}
					}
				}

				&:hover {
					td:not(.td-employee) {
						border-bottom: 1px solid map-get($colors, primary);
						border-top: 1px solid map-get($colors, primary);
						color: black;
						font-family: map-get($fonts, opens-bold);

						&:first-child {
							border-left: 1px solid map-get($colors, primary);
						}

						&:last-child {
							border-right: 1px solid map-get($colors, primary) !important;
						}
					}
				}
			}

			tr.is-select {
				td:not(.td-employee) {
					border-bottom: 1px solid map-get($colors, primary);
					border-top: 1px solid map-get($colors, primary);
					color: grey;
					font-family: map-get($fonts, opens-regular);

					&:first-child {
						border-left: 1px solid map-get($colors, primary);
					}

					&:last-child {
						border-right: 1px solid map-get($colors, primary);
					}
				}

				&-employee {
					td.td-employee {
						border-bottom: 1px solid map-get($colors, primary);
						border-top: 1px solid map-get($colors, primary);
						color: grey;
						font-family: map-get($fonts, opens-regular);

						&:first-child {
							border-left: 1px solid map-get($colors, primary);
						}

						&:last-child {
							border-right: 1px solid map-get($colors, primary);
						}
					}
				}
			}
		}

		tfoot {
			tr {
				td {
					background-color: white;
					border-bottom-left-radius: 10px;
					border-bottom-right-radius: 10px;
					border-top: 1px solid map-get($colors, subheaderText);
					box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .2);
					height: 29px;
					padding-right: 17px;

					a {
						color: map-get($colors, paginationText);
						font-family: map-get($fonts, open-regular);
						font-size: 15px;
						font-weight: lighter;
						line-height: 10px;
						margin-left: 7px;
						padding: 5px;

						& + span {
							color: map-get($colors, grey-border);

							& + a {
								margin-left: 0px;
							}
						}

						&.active-page {
							color: red;
						}
						&:hover {
							font-size: 18px;
						}
					}
				}
			}
		}

		.pagination-footer {
			align-items: center;
			display: flex;
			justify-content: space-between;
			min-height: 48px;
			padding: 5px 2px 5px 12px;
		}

		.pagination-summary {
			align-items: center;
			color: #718396;
			display: flex;
			font-family: map-get($fonts, open-regular);
			font-size: 11px;
			gap: 7px;

			strong { color: #294763; }
		}

		.records-badge {
			background: #EAF3EF;
			border-radius: 6px;
			color: #1A4338;
			font-weight: 700;
			min-width: 25px;
			padding: 4px 7px;
			text-align: center;
		}

		.pagination-divider {
			background: #dce5ee;
			height: 17px;
			margin: 0 3px;
			width: 1px;
		}

		.pagination-controls {
			align-items: center;
			display: flex;
			gap: 4px;

			button {
				align-items: center;
				background: white;
				border: 1px solid #dce5ee;
				border-radius: 7px;
				color: #49657e;
				cursor: pointer;
				display: inline-flex;
				font-family: map-get($fonts, open-regular);
				font-size: 11px;
				height: 30px;
				justify-content: center;
				min-width: 30px;
				outline: none;
				padding: 0 6px;
				transition: background .18s ease, border-color .18s ease, color .18s ease;

				.icon { color: inherit; font-size: 18px; }
				&:hover:not(:disabled) { background: #EEF5F2; border-color: #C4DBD3; color: #1A4338; }
				&:disabled { cursor: default; opacity: .38; }
				&.active-page { background: #1A4338; border-color: #1A4338; color: white; font-weight: 700; }
				&.page-dots { border-color: transparent; opacity: 1; }
			}
		}

		@media (max-width: 700px) {
			.pagination-footer { align-items: flex-start; flex-direction: column; gap: 8px; padding: 9px; }
			.pagination-divider { display: none; }
			.pagination-summary { flex-wrap: wrap; }
			.pagination-controls { max-width: 100%; overflow-x: auto; padding-bottom: 2px; }
		}

		&.no-main-list {
			border-bottom: 1px solid map-get($colors, grey-border);
		}

		.search-input {
			background-color: rgba(0, 0, 0, .2);
			box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, .2);
			border-radius: 3px;
			display: inline-flex;
			height: 23px;
			max-width: 153px;
			vertical-align: middle;

			input {
				color: white;
				font-size: 14px;
				outline: none;
				padding: 0 5px;
				width: calc(100% - 25px);
			}

			.icon {
				align-self: center;
				color: white;
				font-size: 20px;
				transform: rotate(90deg);
			}
		}

		.checkbox {
			.icon {
				font-size: 14px;
			}

			.input-group--selection-controls__ripple {
				height: 15px;
				left: 13px;
				width: 15px;
			}
		}

		.input-checkbox {
			border: 1px solid map-get($colors, grey-border);
			border-radius: 1px;
			height: 12px;
			width: 12px;
		}
	}
	.unique-input {
		border: 1px solid map-get($colors, black);
		opacity: 0.1;
		padding-left: 5px;
		width: 50px;
	}
	.unique-input:focus-within{
		opacity: 1;
	}
	.row-checked {
		background-color: map-get($colors, rowSelected) !important;
	}

	.content-checkbox {
		background-color: white !important;
	}

	/* Modern appearance is kept last so legacy table rules cannot override it. */
	table.table-list.table-modern {
		.table-tools-row {
			align-items: center;
			display: flex;
			justify-content: space-between;
			width: 100%;
		}

		.table-tools-title {
			align-items: center;
			display: flex;
			gap: 9px;
			text-align: left;

			> span {
				align-items: center;
				background: rgba(255, 255, 255, .14);
				border: 1px solid rgba(255, 255, 255, .18);
				border-radius: 8px;
				display: flex;
				height: 30px;
				justify-content: center;
				width: 30px;

				.icon { color: white; font-size: 17px; }
			}

			> div { display: flex; flex-direction: column; }
			strong { color: white; font-size: 11px; line-height: 1.2; }
			small { color: rgba(255, 255, 255, .72); font-size: 8px; font-weight: 400; margin-top: 1px; text-transform: none; }
		}

		.table-tools-actions { align-items: center; display: flex; gap: 4px; }

		thead.primary {
			background: transparent !important;

			tr:first-child th {
				background: #1A4338;
				border-bottom: 1px solid rgba(255, 255, 255, .14);
				border-radius: 10px 10px 0 0;
				color: white;
				height: 44px;
				padding: 5px 10px;

				.search-input {
					background: white;
					border: 1px solid rgba(255, 255, 255, .38);
					box-shadow: none;
					height: 32px;
					max-width: 260px;

					input { color: #334f67; }
					.icon,
					.search-icon {
						color: #315e7f !important;
						opacity: 1 !important;
						text-shadow: none;
					}
				}

				> button {
					background: rgba(255, 255, 255, .14);
					border: 1px solid rgba(255, 255, 255, .2);

					.icon { color: white; }
				}
			}

			tr:last-child th {
				background: #1A4338;
				border-bottom: 1px solid #12372E;
				color: white;
				height: 32px;
				text-align: left;

				&:last-child { text-align: center; }
			}
		}

		tbody tr,
		tbody tr:nth-child(odd),
		tbody tr:nth-child(even) {
			background: white;
			box-shadow: none;
			transform: none;

			td {
				background: white;
				border-bottom: 1px solid #edf1f5 !important;
				color: #40576b;
				font-family: map-get($fonts, opens-regular);
				height: 43px;
				padding: 5px 9px;
				transition: background .16s ease, color .16s ease;
				text-align: left;

				&:last-child { text-align: center; }
			}
		}

		tbody td:last-child {
			> div {
				align-items: center;
				display: inline-flex;
				gap: 2px;
				justify-content: center;
			}

			.action-icon-button {
				background: transparent !important;
				border-color: transparent;
				color: #60788d !important;

				.icon { color: inherit !important; }

				&:hover {
					background: #EAF3EF !important;
					border-color: #D3E3DD;
					color: #1A4338 !important;
				}
			}
		}

		tbody tr:hover,
		tbody tr.row-checked {
			background: #EEF5F2;
			box-shadow: none;
			transform: none;

			td,
			td:not(.td-employee) {
				background: #EEF5F2;
				border-bottom: 1px solid #DFECE7 !important;
				color: #243e55;
			}

			td:first-child {
				border-left: 3px solid #1A4338 !important;
			}
		}

		tfoot {
			background: white;
			box-shadow: none;
			z-index: 10;

			tr td {
				background: white;
				border: 0;
				border-radius: 0 0 10px 10px;
				box-shadow: none;
			}
		}

		@media (max-width: 700px) {
			.table-tools-title small { display: none; }
			.table-tools-actions { flex: 1; justify-content: flex-end; }
		}
	}
</style>

<style lang="scss">
.table-list.table-modern {
	.table-action-cell {
		text-align: center !important;
		white-space: nowrap;

		.table-secondary-action { display: none !important; }
		.table-primary-action { display: inline-flex !important; }
	}

	.table-action-group {
		align-items: center;
		display: inline-flex !important;
		gap: 5px;
		justify-content: center;
		line-height: 1;
		vertical-align: middle;

		.action-icon-button,
		.table-primary-action { margin: 0 !important; vertical-align: middle; }
	}

	.table-action-menu {
		display: inline-flex;
		margin-left: 5px;
		position: relative;
	}

	.table-action-trigger {
		align-items: center;
		background: #edf3f7;
		border: 1px solid transparent;
		border-radius: 7px;
		color: #526d83;
		cursor: pointer;
		display: inline-flex;
		height: 28px;
		justify-content: center;
		outline: none;
		min-width: 28px;
		padding: 0;
		vertical-align: middle;
		width: 28px;

		.material-icons { font-size: 19px; }
		&:hover, &:focus { background: #E5F0EC; border-color: #D0E1DB; color: #1A4338; }
	}

	.table-action-popover {
		background: white;
		border: 1px solid #dce5ed;
		border-radius: 10px;
		box-shadow: 0 12px 30px rgba(27, 50, 72, .18);
		display: none;
		min-width: 190px;
		overflow: hidden;
		padding: 5px;
		position: fixed;
		z-index: 1000;
	}

	.table-action-menu.open .table-action-popover { display: block; }

	.table-action-item {
		align-items: center;
		background: transparent;
		border: 0;
		border-radius: 7px;
		color: #425b70;
		cursor: pointer;
		display: flex;
		font-size: 11px;
		gap: 9px;
		min-height: 34px;
		outline: none;
		padding: 6px 9px;
		text-align: left;
		width: 100%;

		.material-icons { color: var(--action-color, #668096); font-size: 17px; }
		&:hover { background: #EEF5F2; color: #1A4338; }
		&:hover .material-icons { filter: saturate(1.15); }
		&:last-child { border-top: 1px solid #edf1f4; margin-top: 3px; }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/table/app-table.vue